<template>
  <dashboard-header />
  <dashboard-mobile-menu />
  <div class="bg-gray-200 mt-[77px] py-3 px-3 min-h-screen">
    <section class="relative overflow-hidden">
      <div class="flex">
        <div class="w-full">
          <router-view />
        </div>
      </div>
    </section>
  </div>
  <dashboard-footer />

  <button
    data-toggle="back-to-top"
    class="fixed text-sm rounded-full z-10 bottom-5 end-5 h-9 w-9 text-center bg-primary/20 text-primary flex justify-center items-center"
    @click="scrollToTop"
  >
    <i class="fa-solid fa-arrow-up text-base"></i>
  </button>
</template>
<script setup>
import DashboardHeader from "@/components/DashboardLayout/dashboard-components/DashboardHeader.vue";
import DashboardMobileMenu from "@/components/DashboardLayout/dashboard-components/DashboardMobileMenu.vue";
import DashboardFooter from "@/components/DashboardLayout/dashboard-components/DashboardFooter.vue";

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: "smooth" });
};
</script>
